import React from 'react';

import {
    Layout, Button, Alert, Form, Row, Col, Input, Icon, Select, Table
} from 'antd';

import '../App.css';
import Axios from 'axios';
import config from '.././config.json';
import $ from 'jquery';
import { JSONToCSVConvertor } from '../Helpers/ExportToExcel';
import base64_arraybuffer from 'base64-arraybuffer';
const keyvalue = 1;
const FormItem = Form.Item;
const Option = Select.Option;
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 9 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 },
    },
};

function _base64ToArrayBuffer(base64) {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
}

class CRView extends React.Component {

    constructor(props) {
        super(props);
        this.employerDisplayList = [];
        this.employerId = -1;
        this.techId = null;
    }
    state = ({
        data: [],
        employerList: [],
        sortedInfo: null,
    });

    handleSearch = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err || values.display != -1) {
                if (!values.lname) {
                    values.lname = " ";
                }
                if (!values.year) {
                    values.year = 9999; //(new Date()).getFullYear()
                }
                $.ajax({
                    type: 'POST',
                    url: `${config.serverUrl}/api/View/getecrtstudent`,
                    data: values
                })
                    .done((result) => {
                        this.employerId = values.display;
                        this.techId = values.techId;
                        var output = [];
                        result.forEach(function (value) {
                            var existing = output.filter(function (v, i) {
                                return v.StudentId == value.StudentId;
                            });
                            if (existing.length) {
                                var existingIndex = output.indexOf(existing[0]);
                                output[existingIndex].CertificationList = output[existingIndex].CertificationList.concat(value.CertificationList);
                            } else {
                                if (typeof value.CertificationList == 'string')
                                    value.CertificationList = [value.CertificationList];
                                output.push(value);
                            }
                        });

                        this.setState({
                            data: output,
                        });
                        console.log(output);
                    })
                    .fail((jqXhr) => {
                        console.log(jqXhr);
                    });

            }

        });
    }

    download = (record) => {

        console.log(record);
        var data2 = {
            StudentId: record.StudentId, FirstName: record.FirstName, LastName: record.LastName, TechID: record.TechID, Employer: record.Employer
        };
        $.ajax({
            type: 'POST',
            url: `${config.serverUrl}/api/View/printcert`,
            data: { info: data2, cert: record.CertificationList, system:2  }
        })
            .done((result) => {

                var byteArray = _base64ToArrayBuffer(result);
                var blob = new Blob([byteArray], { type: "application/pdf;charset=utf-8" });
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, "certificate.pdf");
                    //window.navigator.msSaveBlob(blob, "certificate.pdf"); Commented out by Megan Bouret as it was requested the PDF be opened instead of saved
                    console.log('pdf save to disk')
                }
                else {
                    var downloadpdf = $('<a id="downloadpdf" download="certificate.pdf" href="data:application/pdf;base64,' + result + '" >');
                    $('body').append(downloadpdf);
                    document.getElementById("downloadpdf").click();
                    $("#downloadpdf").remove();
                    console.log('pdf download.')
                }

            })
            .fail((jqXhr) => {
                console.log('failed to down certificate');
            });
    }

    handleChangeSort = (pagination, filters, sorter) => {
        this.setState({
            sortedInfo: sorter,
        });
    }

    handleReset = () => {
        this.props.form.resetFields();
    }

    compareByChar(a, b) { if (a > b) { return -1; } if (a < b) { return 1; } return 0; }

    render() {
        const { getFieldDecorator } = this.props.form;

        let { sortedInfo } = this.state;
        sortedInfo = sortedInfo || {};
        const columns = [{
            title: 'Action',
            key: 'action',
            render: (text, record) => (
                <span>
                    <a onClick={() => this.download(record)}>View PDF</a>
                </span>
            ),
        }, {
            title: 'First Name',
            dataIndex: 'FirstName',
            key: 'FirstName',
            sorter: (a, b) => this.compareByChar(a.FirstName, b.FirstName),
            sortOrder: sortedInfo.columnKey === 'FirstName' && sortedInfo.order,
        }, {
            title: 'Last Name',
            dataIndex: 'LastName',
            key: 'LastName',
        },
        {
            title: 'Employer',
            dataIndex: 'Employer',
            key: 'Employer',
            sorter: (a, b) => this.compareByChar(a.Employer, b.Employer),
            sortOrder: sortedInfo.columnKey === 'Employer' && sortedInfo.order,
        }, {
            title: 'Certification',
            key: 'Certification',
            render: function (text, record) {
                const test = record.CertificationList;
                return (
                    <div>
                        {test.map(function (d, idx) {
                            return (<li key={idx}>{d.Name}</li>)
                        })}
                    </div>
                );

            },
        }, {
            title: 'Valid Through',
            key: 'ValidThrough',
            render: function (text, record) {
                const test = record.CertificationList;
                return (
                    <div>
                        {test.map(function (d, idx) {
                            return (<li key={idx}>{d.Month}/{d.NumberOfYearsValid}</li>)
                        })}
                    </div>
                );

            },
        }];

        return (
            <div>
                <h1 style={{ textAlign: 'left' }} >Civil Rights Certification Registry</h1>
                <hr />
                <div className="container">
                    <div style={{ 'width': '800px' }} className="panel panel-default">
                        <div className="panel-heading">
                            <h2>Search Criteria</h2>
                        </div>
                        <br />
                        <Form onSubmit={this.handleSearch}>
                            <FormItem
                                {...formItemLayout}
                                label="Last Name"
                            >
                                {getFieldDecorator('lname', {
                                })(<Input placeholder="Last Name" />
                                )}
                            </FormItem>

                            <FormItem
                                {...formItemLayout}
                                label="Select Employer from the List"
                            >
                                {getFieldDecorator('display', {
                                    initialValue: "-1",

                                })(
                                    <Select
                                        showSearch
                                        style={{ width: '100%' }}
                                        searchPlaceholder="Enter Company Name"
                                        optionFilterProp="children"
                                        onChange={this.handleChangeEmployer}
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    >
                                        {this.employerDisplayList}
                                    </Select>)}

                            </FormItem>
                            <FormItem
                                {...formItemLayout}
                                label="Valid Through Year"
                            >
                                {getFieldDecorator(`year`)(
                                    <Input type="text" placeholder="Valid Year" style={{ width: '40%' }} />
                                )}
                            </FormItem>
                            <Row>
                                <Col span={48} style={{ textAlign: 'left' }}>
                                    <center>
                                        <button type="submit" className="btn btn-default">Submit</button>
                                        &nbsp;&nbsp;&nbsp;
                                        <button type="reset" className="btn btn-default" onClick={this.handleReset}>Clear</button>
                                    </center>
                                </Col>
                            </Row>
                        </Form>
                        <br />
                    </div>
                    <br />
                </div>
                <div>
                    <Button type="primary"
                        style={{
                            marginBottom: 10, marginLeft: 10, background: 'MediumSeaGreen',
                            borderColor: 'MediumSeaGreen'
                        }}
                        onClick={this.excelExport}> Export to Excel</Button>
                    <Table rowKey="StudentId" columns={columns} dataSource={this.updateData(this.state.data, this.employerId)} onChange={this.handleChangeSort} size="small" bordered />
                </div>

            </div>


        );
    }

    excelExport = () => {
        var data = this.updateData(this.state.data, this.employerId);
        var newList = data.map(function (item) {
            const cert = item.CertificationList[0];
            return {
                StudentId: item.StudentId,
                EmployerId: item.EmployerId,
                FirstName: item.FirstName,
                LastName: item.LastName,
                TechId: item.TechID,
                Employer: item.Employer,
                Certification: cert.Name,
                ValidThrough: cert.Month + "/" + cert.NumberOfYearsValid,
            }
        });
        console.log(newList);

        try {
            JSONToCSVConvertor(newList, "Certification Registry", true, 'text/csv;encoding:utf-8');
        }
        catch (error) {
            console.log("Error in excelExport");
        }
    }

    updateData(data, employerId) {
        if (this.employerId != -1) {
            data = data.filter(function (item) {
                if (item.EmployerId == employerId) {
                    return true;
                }
            });
        }

        if (typeof this.techId === 'undefined' || this.techId === null || this.techId === '') {
            return data;
        }

        else {
            var techId = this.techId;
            console.log(techId)
            data = data.filter(function (item) {
                if (item.TechID == techId) {
                    return true;
                }
            });
        }
        return data;
    }


    employerDropdown = () => {
        this.employerDisplayList = [];
        $.ajax({
            type: 'POST',
            url: `${config.serverUrl}/api/registration/getallcremployer`
        })
            .done((data) => {

                for (let i = 0; i < data.length; i++) {
                    var optDis = data[i].CompanyName + ", " + data[i].City + " (" + data[i].State + ")";
                    this.employerDisplayList.push(
                        <Option key={data[i].Id}>{optDis}</Option>
                    );
                }

                this.employerDisplayList.push(
                    <Option key="-1">None</Option>
                );

                this.setState({
                    employerList: data
                });

            })
            .fail((jqXhr) => {
                console.log('failed to get employer');
            });

    }

    componentDidMount() {
        this.employerDropdown();

    }



}

const WrappedAdvancedSearchForm = Form.create()(CRView);
export default WrappedAdvancedSearchForm;





// WEBPACK FOOTER //
// ./src/CourseViews/CivilRights.js